export const CONTACT = {
  email: "Tatianakouame2024@gmail.com",
  phone: "05 65 58 20 74",
  phoneIntl: "+225 05 65 58 20 74",
  whatsapp: "2250565582074",
  brand: "MaxiChoix",
  city: "Abidjan, Côte d'Ivoire",
};

export const UNIVERSES = [
  { key: "Maison & Pratique", categories: ["nettoyage"] },
  { key: "Voyage & Auto", categories: ["accoudoirs", "visieres"] },
  { key: "Maternité & École", categories: ["sacs-dos", "sacs-ecole"] },
  { key: "Bien-être", categories: ["gourdes"] },
];

export const formatFCFA = (n) =>
  new Intl.NumberFormat("fr-FR").format(n) + " FCFA";

export const waLink = (message) =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(message)}`;
